module.exports = __webpack_public_path__ + "img/Dantam Hair 40.d6106217.jpg";